import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule } from "@angular/router";
import { VehicleComponent } from "./components/vehicle/vehicle.component";
import { CompetitorVehicleComponent } from "./components/reports/competitor-vehicle/competitor-vehicle.component";
import { HomepageComponent } from "./components/homepage/homepage.component";
import { ReferenceTableComponent } from "./components/reference-table/reference-table.component";
import { PropulsionRolloutComponent } from "./components/reports/propulsion-rollout/propulsion-rollout.component";
import { VehicleRolloutComponent } from "./components/reports/vehicle-rollout/vehicle-rollout.component";
import { DocumentComponent } from "./components/document/document.component";
import { CompetitiveActivityLandscapeComponent } from "./components/reports/competitive-activity-landscape/competitive-activity-landscape.component";
import { EditableTableComponent } from "./components/editable-table/editable-table.component";
import { VehicleVersionReportComponent } from "./components/reports/vehicle-version-report/vehicle-version-report.component";
@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        { path: "view/:view", component: EditableTableComponent },
        { path: "vehicle/:id", component: VehicleComponent },
        { path: "reference/:table", component: ReferenceTableComponent },
        {
          path: "reports/vehicleVersions",
          component: VehicleVersionReportComponent,
        },
        {
          path: "reports/competitorVehicles",
          component: CompetitorVehicleComponent,
        },
        {
          path: "reports/propulsionRollout",
          component: PropulsionRolloutComponent,
        },
        { path: "reports/vehicleRollout", component: VehicleRolloutComponent },
        {
          path: "reports/competitiveActivityLandscape",
          component: CompetitiveActivityLandscapeComponent,
        },
        { path: "", component: HomepageComponent },
        { path: "editabledocs/:docname", component: DocumentComponent },
      ],
      { preloadingStrategy: PreloadAllModules }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
